import React, { useState } from "react";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import {
  FolderIconBlue,
  ArrowUpRightBlue,
  FolderIconCheckDoneBlue,
} from "../../../../constant/imagePath";
import { BeforeLoginHeader } from "../../../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon.jsx";
import classes from "./BackgroundCheckMobile.module.css";
import { ReactSVG } from "react-svg";
import PageProgressBar from "../../../../stories/PageProgressBar/PageProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { setPersonalData } from "../../../../store/Actions/authAction";

export default function BackgroundCheckMobile({ stepForwardAndBackward }) {
  const history = useHistory();
  const getDataFromRedux = useSelector(
    (state) => state.onBoardingReducer?.backgroundCheck
  );

  const [checkInfo, setCheckInfo] = useState(getDataFromRedux ? getDataFromRedux : false);
  const dispatch = useDispatch();

  // Save And Finish Later
  function saveAndFinishLater() {
    dispatch(setPersonalData("background-check", checkInfo));
  }

  return (
    <div className={classes.backgroundCheck}>
      <div className={classes.progressLine}>
        <PageProgressBar progress={'33.3%'} />
      </div>

      <Row className={`g-0 ${classes.row}`}>
        <Col md={12} className={`${classes.innerContainer}`}>
          <Col md={12}>
            <h3
              style={{
                ...Fonts.h3,
                fontSize: "24px",
                lineHeight: "32px",
                color: Colors.neutralShadesOfNero,
              }}
            >
              Background Check
            </h3>

            <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
              We need to check some information about you before posting your
              profile on our site.
            </p>
          </Col>

          {checkInfo ? (
            <Col md={12} style={{ marginTop: "24px" }}>
              <div
                className={classes.startBackgroundCheckbox}
                style={{
                  border: `1px solid ${Colors.neutralShadesOfWhisper}`,
                  height: "204px",
                }}
              >
                <div className={classes.boxContent}>

                  <ReactSVG src={FolderIconCheckDoneBlue} beforeInjection={(svg) => {
                    svg.classList.add(classes.img)
                  }} />

                  <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>
                    We will check your background info as soon as possible.
                  </p>

                  <div>
                    <LinkButtonWithIcon
                      text={"Change background info"}
                      primary={true}
                      rightIcon={ArrowUpRightBlue}
                      customStyle={{ marginTop: "24px" }}
                      iconStyle={{
                        width: "16px",
                        height: "16px",
                        margin: "auto",
                        marginLeft: "0px",
                      }}
                    />
                  </div>
                </div>
              </div>
            </Col>
          ) : (
            <Col md={12} style={{ marginTop: "24px" }}>
              <div
                className={classes.startBackgroundCheckbox}
                style={{
                  border: `1px solid ${Colors.neutralShadesOfWhisper}`,
                }}
              >
                <div className={classes.boxContent}>
                  <ReactSVG src={FolderIconBlue} beforeInjection={(svg) => {
                    svg.classList.add(classes.img)
                  }} />

                  <div className={classes.title}>
                    <LinkButtonWithIcon
                      text={"Start background check"}
                      rightIcon={ArrowUpRightBlue}
                      primary={true}
                      customStyle={{ marginTop: "24px" }}
                      iconStyle={{
                        width: "16px",
                        height: "16px",
                        margin: "auto",
                        marginLeft: "0px",
                      }}
                      onClick={() => setCheckInfo(true)}
                    />
                  </div>
                </div>
              </div>
            </Col>
          )}
        </Col>
        {/* Btns Col */}

        <Col
          md={12}
          style={{
            borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
            backgroundColor: Colors.white
          }}
          className={`${[classes.btnsCol].join(" ")}`}
        >
          <div className={classes.btnsBox}>
            <LinkButtonWithIcon
              text={"Go Back"}
              customStyle={{
                ...Fonts.b2,
                lineHeight: "20px",
                width: "max-content",
                height: "56px",
              }}
              onClick={() => stepForwardAndBackward(1, 1)}
            />
            <Button
              label={"Next"}
              primary={true}
              size={"Large"}
              customStyle={{ ...Fonts.b1, width: "156px", height: "56px" }}
              onClick={() => {
                saveAndFinishLater()
                stepForwardAndBackward(2, 1)
              }}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}
